import { render, staticRenderFns } from "./EditDeposit.vue?vue&type=template&id=537f4972&scoped=true&"
import script from "./EditDeposit.vue?vue&type=script&lang=js&"
export * from "./EditDeposit.vue?vue&type=script&lang=js&"
import style0 from "./EditDeposit.vue?vue&type=style&index=0&id=537f4972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f4972",
  null
  
)

export default component.exports